var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import ReportModel from "../../models/ReportModel";
import PersistentCollection from "../PersistentCollection";
/**
 *
 */
var ReportCollection = /** @class */ (function (_super) {
    __extends(ReportCollection, _super);
    /**
     *
     */
    function ReportCollection() {
        return _super.call(this, ReportModel, true, 'ReportCollection') || this;
    }
    /**
     *
     */
    ReportCollection.prototype.resetAll = function () {
        this.reset(true);
        this.fetching = null; // Promise
        this.firstFetchComplete = false;
    };
    return ReportCollection;
}(PersistentCollection));
export default ReportCollection;
